import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router'
@Component({
  selector: 'app-message-compose',
  templateUrl: './message-compose.component.html',
  styleUrls: ['./message-compose.component.scss']
})
export class MessageComposeComponent implements OnInit {
  @Input() hidden;
  @Input() messageData;
  @Input() isEdit;
  @Input() currentStudentUserId: any;
  @Input() currentStudentProfileId: any;
  @Output() composeBoxShow: EventEmitter<any> = new EventEmitter();
  @Output() renderGrid: EventEmitter<any> = new EventEmitter();
  messageTopic = '';
  messageContent = '';
  messageFileComponentArray: any[] = [
    {
      id: '0',
      disable: false,
      upload: false,
      uploaded: false,
      attachmentData: {}
    }
  ];
  threadId: number;
  uploadFileData = [];
  selectedCategoryIds = [];
  userId: string;
  coachUserId: string;
  profileId: string;
  queueData: any[];
  roleName: string;
  fromUserId: string;
  toUserId: string;
  title = false;
  currentMessagePartnerId: number;
  cc: any;
  userIdArray = [];
  to: any;
  toEmail: string;
  attachmentIdArray = [];
  documentUserFileId = [];
  sharedAttachmentFileArray = [];
  defaultArr = [];
  pageUrl: string;
  fileUploaded = new EventEmitter();
  toUserIdArray = [];
  familyDetails: any;
  presentId: number;
  assignmentType: any;
  assignmentSubType: any;
  constructor(
    protected notificationService: NotificationService,
    private _commonAuthService: CommonAuthenticationService,
    protected _commonDataSharedService: CommonDataSharedService,
    protected _commonRequestResponseService: CommonRequestResponseService,
    protected _commonService: CommonService,
    protected _router: Router,
  ) { }

  ngOnInit() {
    this.defaultArr.push('partnerId');
    this.setUserData();
    this.setMessageDefaultData();
    this.resetFileData();
    this.getQueueData();
  }

  setUserData() {
    this.userId = this._commonAuthService.getUserId();
    this.profileId = this._commonAuthService.getProfileId();
    this.roleName = this._commonAuthService.getModule().toLowerCase();
    switch (this.roleName) {
      case 'coach':
        this.fromUserId =
          this.messageData && this.messageData.createdByUserId
            ? this.messageData.createdByUserId
            : this.userId.toString();
        this.toUserId =
          this.messageData && this.messageData.fromUserId
            ? this.messageData.fromUserId
            : this.currentStudentUserId;
        this.coachUserId = this.currentStudentUserId
          ? this.currentStudentUserId
          : this.userId.toString();
        this.pageUrl = this.messageData.messageFromScreen[5];
        this.getFamilyDetails(this.pageUrl);
        break;
      case 'student':
        this.fromUserId = this.userId.toString();
        this.toUserId = '-1';
        break;
      case 'parent':
        this.fromUserId = this.userId.toString();
        this.toUserId = this.messageData
          ? this.messageData.recipientID
          : this.userId.toString();
        break;
    }
  }

  setMessageDefaultData() {
    if (this.isEdit) {
      this.sharedAttachmentFileArray = [];
      this.attachmentIdArray = [];
      this.to = [];
      this.cc = [];
      this.userIdArray = [];
      this.messageTopic = this.messageData.subject;
      this.title = true;
      this.threadId = this.messageData.messageID
        ? this.messageData.messageID
        : this.messageData.messageId;
      this.currentMessagePartnerId = this.messageData.partnerId
        ? this.messageData.partnerId
        : this._commonAuthService.getPartnerId();
    } else {
      this.sharedAttachmentFileArray = [];
      this.attachmentIdArray = [];
      this.to = [];
      this.cc = [];
      this.title = false;
      this.userIdArray = [];
      this.messageTopic = '';
      this.messageContent = '';
      this.threadId = 0;
    }
    if (this.messageData && this.messageData.messageFromScreen) {
      this.pageUrl = this.messageData.messageFromScreen[5];
    }
  }

  uploadFile(data: any) {
    this.selectedCategoryIds.push(data.attachmentData.selectedCategoryId);
    let inputJson;
    const attachmentData = data.attachmentData;
    const currentFileUploadId = data.id;
    if (
      attachmentData &&
      !attachmentData.selectedCategory &&
      this.roleName !== 'coach'
    ) {
      this.notificationService.show(
        'error',
        'Please choose a category when upload is clicked without a category'
      );
    } else if (
      attachmentData &&
      !attachmentData.selectedCategory &&
      this.roleName !== 'parent'
    ) {
      this.notificationService.show(
        'error',
        'Please choose a category when upload is clicked without a category'
      );
    }
    if (attachmentData && attachmentData.fileData.length === 0) {
      this.notificationService.show('error', 'Please choose a  file to upload');
    } else {
      data.uploaded = true;
      inputJson = {
        fileName: attachmentData.fileData[0].fileName,
        file: attachmentData.fileData[0].fileBytes.toString()
      };

      switch (this.roleName) {
        case 'student':
          inputJson.studentUserId = this.userId.toString();
          inputJson.documentTypeClassId = attachmentData.selectedCategoryId;
          inputJson.documentTypeClassName = attachmentData.selectedCategory;
          this.uploadFileToSharedAttachment(
            attachmentData,
            currentFileUploadId
          );
          break;
        case 'parent':
          inputJson.parentUserId = this.userId.toString();
          inputJson.documentTypeClassId = attachmentData.selectedCategoryId;
          inputJson.documentTypeClassName = attachmentData.selectedCategory;
          this.uploadFileToStudentDocument(inputJson, currentFileUploadId);
          break;
        case 'coach':
          inputJson.coachUserId = this.coachUserId.toString();
          this.uploadFileToSharedAttachment(
            attachmentData,
            currentFileUploadId
          );
          break;
        case 'parent':
          inputJson.parentUserId = this.userId.toString();
          this.uploadFileToSharedAttachment(
            attachmentData,
            currentFileUploadId
          );
          break;
      }
    }
  }

  uploadFileToSharedAttachment(
    attachmentData: any,
    currentFileUploadId: string
  ) {
    let serviceUrl;
    const assignmentData = JSON.parse(localStorage.getItem('assignmentData'));
    const inputJson = {
      file: attachmentData.fileData[0].fileBytes.toString(),
      fileName: attachmentData.fileData[0].fileName,
      documentTypeClassId: attachmentData.selectedCategoryId,
      fromUserId: this.toUserId,
      forStudent: assignmentData ? assignmentData.studentId : this.toUserId
    };
    this.sharedAttachmentFileArray.push(inputJson);
    if (this.currentMessagePartnerId) {
      inputJson['partnerId'] = this.currentMessagePartnerId;
      serviceUrl = this._commonRequestResponseService.postWithHeader(
        'shared/attachment/',
        inputJson,
        this.defaultArr
      );
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader(
        'shared/attachment/',
        inputJson
      );
    }

    serviceUrl.subscribe(
      (response: any) => {
        this.notificationService.show('success', 'File upload successfully');
        if (response && response.attachmentId) {
          this.attachmentIdArray.push(response.attachmentId);
          this.messageFileComponentArray[currentFileUploadId].disable = true;
          this.fileUploaded.emit(response.attachmentId);
          if (this.messageFileComponentArray.length < 5) {
            this.messageFileComponentArray.push({
              id: this.messageFileComponentArray.length,
              disable: false,
              upload: false,
              attachmentData: {}
            });
          }
        }
      },
      error => console.error(error)
    );
  }

  uploadFileToStudentDocument(inputJson, currentFileUploadId) {
    this._commonRequestResponseService
      .postWithHeader('shared/attachment', inputJson)
      .subscribe(
        (response: any) => {
          if (response && response.attachmentId) {
            this.attachmentIdArray.push(response.attachmentId);
          }
          this.notificationService.show(
            'success',
            'Document uploaded successfully!'
          );
          this.messageFileComponentArray[currentFileUploadId].disable = true;
          this.messageFileComponentArray[currentFileUploadId].upload = true;
          if (this.messageFileComponentArray.length < 5) {
            this.messageFileComponentArray.push({
              id: this.messageFileComponentArray.length,
              disable: false,
              upload: false,
              attachmentData: {}
            });
          }
          this.uploadFileData.push(response);
          this.documentUserFileId.push(response.documentId);
          this.fileUploaded.emit(response.documentId);
        },
        () => {
          this.notificationService.show(
            'error',
            'Error while uploading document'
          );
        }
      );
  }

  deleteFile(id) {
    if (!id) {
      return;
    }

    if (this.uploadFileData) {
      this.uploadFileData.splice(id, 1);
    }

    if (this.attachmentIdArray) {
      this.attachmentIdArray.splice(id, 1);
    }
  }

  onSendMessage(form: NgForm) {
    if (form.valid) {
      this.getQueueData();
      this.setSendMessageInputJson(form);
    } else {
      this.notificationService.show(
        'error',
        'Please add subject and message both'
      );
    }
  }

  setSendMessageInputJson(form) {
    if (this.messageData && this.messageData.queueData) {
      this.assignmentType = this.getQueueType(
        this.messageData.messageAssignmentType,
        this.messageData.queueData
      );
      this.assignmentSubType = this.messageData.messageAssignmentSubType
        ? this.messageData.messageAssignmentSubType.value
        : 0;
    }
    if (this.assignmentType) {
      this.getDocumentUserFileData(form);
      this.callApi(form, this.assignmentType, this.assignmentSubType);
    } else {
      this.callApi(form, '', '');
    }
  }

  callApi(form, assignmentType, assignmentSubType) {
    const parentID = localStorage.getItem('selectedStudentParentId');
    if (this.toEmail) {
      let selectedEmails = [];
      selectedEmails = this.toEmail.split(',');
      const emailAddresses = selectedEmails.map(el => el.trim());
      this.toUserIdArray = [];
      if (this.familyDetails && emailAddresses) {
        this.familyDetails.forEach(items => {
          if (
            emailAddresses.includes(items.emailAddress) &&
            !this.toUserIdArray.includes(items.id)
          ) {
            this.toUserIdArray.push(items.id);
          }
        });
      }
    }

    let moduleName;
    let inputJson = {};
    let apiUrl;
    let serviceUrl;
    let essayData;
    let assignmentData;
    if (this.messageData && this.messageData.messageFromScreen) {
      moduleName = this.messageData.messageFromScreen[4];
      this.pageUrl = this.messageData.messageFromScreen[5];
    }
    const sendMessageSettingsData = {};
    const isParentCompose = this.pageUrl === 'studentSummary' && parentID;
    if (
      moduleName === 'student' ||
      moduleName === 'parent' ||
      isParentCompose
    ) {
      apiUrl = 'shared/message';
      inputJson = {
        fromUserId: isParentCompose ? this.userId : this.fromUserId,
        toUserId: isParentCompose ? parentID : -1,
        subject: form.value.messageTopic,
        threadId: this.threadId,
        body: form.value.messageContent,
        attachmentIds: this.attachmentIdArray ? this.attachmentIdArray : [],
        partnerId: this.currentMessagePartnerId,
        isParent: this.isEdit,
        emailAddressesToSend: this.toEmail,
        parentSentOnBehalfOfStudentId:
          this.roleName === 'parent' && this.attachmentIdArray.length
            ? localStorage.getItem('parentStudentId')
            : '0'
      };
    } else if (moduleName === 'coach' && this.pageUrl === 'comMessages') {
      essayData = JSON.parse(localStorage.getItem('essayData'));
      assignmentData = JSON.parse(localStorage.getItem('assignmentData'));
      let toUserList = [];
      apiUrl = 'coach/communicationcenter/send/';
      if (this.userIdArray.length > 0) {
        toUserList = this._commonService.findUnique(this.userIdArray);
      } else {
        toUserList = [];
      }
      if (essayData !== null) {
        const arr = [];
        arr.push(essayData.toUserIds);
        inputJson = {
          toUserIds: this.toUserIdArray,
          emailAddressesToSend: this.toEmail,
          messageId: essayData.messageId,
          subject: essayData.subject,
          body: this.messageContent,
          attachmentIds: this.attachmentIdArray ? this.attachmentIdArray : [],
          documentFileIds:
            this.documentUserFileId && this.documentUserFileId.length > 0
              ? this.documentUserFileId
              : [],
          assignmentType: assignmentType ? assignmentType : 0,
          assignmentSubType: assignmentSubType ? assignmentSubType : 0,
          partnerId: this.currentMessagePartnerId,
          isParent: !!this.cc
        };
      } else if (assignmentData !== null) {
        const arr = [];
        arr.push(assignmentData.toUserIds);
        inputJson = {
          toUserIds: this.toUserIdArray,
          emailAddressesToSend: this.toEmail,
          messageId: assignmentData.messageId,
          subject: assignmentData.subject,
          body: this.messageContent,
          attachmentIds: this.attachmentIdArray ? this.attachmentIdArray : [],
          documentFileIds:
            this.documentUserFileId && this.documentUserFileId.length > 0
              ? this.documentUserFileId
              : [],
          assignmentType: assignmentType ? assignmentType : 0,
          assignmentSubType: assignmentData.assignmentSubType
            ? assignmentData.assignmentSubType
            : 0,
          partnerId: this.currentMessagePartnerId,
          isParent: !!this.cc
        };
      } else {
        inputJson = {
          toUserIds: this.toUserIdArray,
          emailAddressesToSend: this.toEmail,
          messageId: this.messageData.messageId,
          subject: this.messageData.subject,
          body: this.messageContent,
          attachmentIds: this.attachmentIdArray ? this.attachmentIdArray : [],
          documentFileIds:
            this.documentUserFileId && this.documentUserFileId.length > 0
              ? this.documentUserFileId
              : [],
          assignmentType: assignmentType ? assignmentType : 0,
          assignmentSubType: assignmentSubType ? assignmentSubType : 0,
          partnerId: this.currentMessagePartnerId,
          isParent: !!this.cc
        };
      }
    } else if (moduleName === 'coach' && this.pageUrl === 'assignment') {
      assignmentData = JSON.parse(localStorage.getItem('assignmentData'));

      let toUserList = '';
      apiUrl = 'coach/assignments/send/';

      if (this.userIdArray.length > 0) {
        toUserList = this._commonService
          .findUnique(this.userIdArray)
          .toString();
      } else {
        toUserList = '';
      }
      inputJson = {
        toUser: assignmentData.studentId,
        toUserIds: this.toUserIdArray,
        emailAddressesToSend: this.toEmail,
        messageId: this.messageData.messageId,
        subject: this.messageData.subject,
        text: this.messageContent,
        attachmentIds: this.attachmentIdArray ? this.attachmentIdArray : [],
        documentFileIds:
          this.documentUserFileId && this.documentUserFileId.length > 0
            ? this.documentUserFileId
            : [],
        assignmentSubType: assignmentSubType ? assignmentSubType : 0,
        partnerId: this.currentMessagePartnerId,
        isParent: !!this.cc
      };
    } else if (moduleName === 'coach' && this.pageUrl === 'essays') {
      let toUserList = [];
      apiUrl = 'coach/essays/send/';

      if (this.userIdArray.length > 0) {
        toUserList = this._commonService.findUnique(this.userIdArray);
      } else {
        toUserList = [];
      }
      inputJson = {
        toUserIds: this.toUserIdArray,
        emailAddressesToSend: this.toEmail,
        messageId: this.messageData.messageId,
        subject: this.messageData.subject,
        body: this.messageContent,
        attachmentIds: this.attachmentIdArray ? this.attachmentIdArray : [],
        documentFileIds:
          this.documentUserFileId && this.documentUserFileId.length > 0
            ? this.documentUserFileId
            : [],
        completed: true,
        partnerId: this.currentMessagePartnerId,
        isParent: !!this.cc
      };
    } else if (
      moduleName === 'coach' &&
      this.pageUrl === 'coachStudentDetail'
    ) {
      apiUrl = 'shared/Coachmessage';
      inputJson = {
        toUserIds: this.toUserIdArray,
        emailAddressesToSend: this.toEmail,
        fromUserId: this.fromUserId,
        toUserId: this.toUserId,
        subject: form.value.messageTopic,
        threadId: this.threadId,
        body: form.value.messageContent,
        attachmentIds: this.attachmentIdArray ? this.attachmentIdArray : [],
        partnerId: this.currentMessagePartnerId,
        isCoach: 1
      };
    }

    sendMessageSettingsData['inputJson'] = inputJson;
    sendMessageSettingsData['apiUrl'] = apiUrl;
    if (sendMessageSettingsData) {
      if (this.currentMessagePartnerId) {
        serviceUrl = this._commonRequestResponseService.postWithHeader(
          sendMessageSettingsData['apiUrl'],
          sendMessageSettingsData['inputJson'],
          this.defaultArr
        );
      } else {
        serviceUrl = this._commonRequestResponseService.postWithHeader(
          sendMessageSettingsData['apiUrl'],
          sendMessageSettingsData['inputJson']
        );
      }

      serviceUrl.subscribe(
        (res: Response) => {
          if (essayData) {
            this.moveCommMessage(essayData, 'essay', '');
          }
          if (assignmentData) {
            this.moveCommMessage(assignmentData, 'assignment', '');
          }

          localStorage.removeItem('essayData');
          localStorage.removeItem('assignmentData');
          this.resetMessage();
          this.resetFileData();
          this.uploadFileData = [];
          this._commonDataSharedService.updateMessageCount.next();
          this.notificationService.show(
            'success',
            'Message data saved successfully'
          );
          this.renderGrid.emit();
        },
        () => {
          this.notificationService.show(
            'error',
            'Error while saving message data'
          );
        }
      );
    }
  }

  getDocumentUserFileData(form) {
    for (let i = 0; i < this.sharedAttachmentFileArray.length; i++) {
      const inputJson = {
        studentUserId: this.fromUserId,
        fileName: this.sharedAttachmentFileArray[i].fileName,
        file: this.sharedAttachmentFileArray[i].file.toString()
      };
      this._commonRequestResponseService
        .postWithHeader('shared/attachment', inputJson)
        .subscribe(
          (response: any) => {
            if (response && response.documentId) {
              this.documentUserFileId.push(response.documentId);
            }
          },
          () => {
            this.notificationService.show(
              'error',
              'Error while uploading document'
            );
          }
        );
    }
  }

  resetFileData() {
    this.messageFileComponentArray = [
      { id: '0', disable: false, upload: false, attachmentData: {} }
    ];
  }

  resetMessage() {
    let resetMessageJson = {};
    this.isEdit = false;
    this.messageTopic = '';
    this.messageContent = '';
    this.hidden = true;
    resetMessageJson = { hidden: this.hidden, isEdit: this.isEdit };
    this.composeBoxShow.emit(resetMessageJson);
  }

  getFamilyDetails(pageUrl) {
    const ccArr = [];
    const toArr = [];
    if (this.roleName === 'coach' && pageUrl === 'studentSummary') {
      const localParentId = JSON.parse(
        localStorage.getItem('parentChildLocalData')
      );
      this.presentId = localParentId.parentUserId;
    } else {
      this.presentId =
        this.messageData.fromUserId || localStorage.getItem('studentLocalId');
    }
    const inputJson = {
      studentId: this.presentId,
      uniqueLinkedAccounts: 0
    };
    let serviceUrl;

    if (this.currentMessagePartnerId) {
      inputJson['partnerId'] = this.currentMessagePartnerId;
      serviceUrl = this._commonRequestResponseService.postWithHeader(
        'shared/familydetails',
        inputJson,
        this.defaultArr
      );
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader(
        'shared/familydetails',
        inputJson
      );
    }
    serviceUrl.subscribe(
      (data: any) => {
        if (data && data.items) {
          this.familyDetails = data.items;
          for (let i = 0; i < data.items.length; i++) {
            if (data.items[i].role.toLowerCase() === 'parent') {
              if (!this.toUserIdArray.includes(data.items[i].id)) {
                this.toUserIdArray.push(data.items[i].id);
              }
              this.userIdArray.push(this.messageData.fromUserId);
              ccArr.push(data.items[i].emailAddress);
              this.cc = ccArr.toString();
            } else if (data.items[i].role.toLowerCase() === 'student') {
              if (!this.toUserIdArray.includes(data.items[i].id)) {
                this.toUserIdArray.push(data.items[i].id);
              }
              toArr.push(data.items[i].emailAddress);
              this.userIdArray.push(this.messageData.fromUserId);
              this.to = toArr.toString() + ccArr.toString();
            } else {
              this.userIdArray.push(this.messageData.fromUserId);
            }
          }
          this.to = this.to + ',' + this.cc;
          this.toEmail = data.toEmail;
        }
      },
      () => {
        this.notificationService.show(
          'error',
          'Error while fetching family details'
        );
      }
    );
  }

  getQueueType(type, queueData) {
    const result = queueData
      .map((data: any) => (data.text.toLowerCase() === type ? data.value : ''))
      .filter(function (e) {
        return e !== '';
      });
    return result[0];
  }

  getQueueData() {
    const selectedType = {
      classTypeName: 'Assignment Types'
    };
    let serviceUrl;
    const defaultArr = [];
    defaultArr.push('partnerId');
    selectedType['partnerId'] = this.currentMessagePartnerId;
    if (this.currentMessagePartnerId) {
      serviceUrl = this._commonRequestResponseService.postWithHeader(
        'admin/values/',
        selectedType,
        defaultArr
      );
    } else {
      serviceUrl = this._commonRequestResponseService.postWithHeader(
        'admin/values/',
        selectedType
      );
    }
    serviceUrl.subscribe(
      (data: any) => {
        this.queueData = [];
        this.queueData = this._commonService.findUnique(data.items);
      },
      () => {
        this.notificationService.show(
          'error',
          'Error while fetching assignment type data'
        );
      }
    );
  }

  moveCommMessage(item, type, itemObj) {
    let queueClassId;
    let assignmentType;
    let serviceUrl;
    if (type === 'essay') {
      queueClassId = this.getQueueType(type, this.queueData);
      assignmentType = 0;
    } else {
      queueClassId = this.getQueueType(type, this.queueData);
      assignmentType = itemObj
        ? itemObj.value
        : item
          ? item.assignmentSubType
          : '';
    }
    const inputJson = {
      messageId: item.messageId,
      queueClassId: queueClassId,
      assignmentClassId: assignmentType
    };
    if (this._router.url !== '/coach/assignment') {
      if (this.getCurrentMessagePartnerId(item)) {
        inputJson['partnerId'] = this.getCurrentMessagePartnerId(item);
        serviceUrl = this._commonRequestResponseService.postWithHeader(
          'coach/communicationcenter/move',
          inputJson,
          this.defaultArr
        );
      } else {
        serviceUrl = this._commonRequestResponseService.postWithHeader(
          'coach/communicationcenter/move',
          inputJson
        );
      }
      serviceUrl.subscribe(
        () => {
          this.notificationService.show('success', 'Message move successfully');
        },
        () => {
          this.notificationService.show('error', 'Error while fetching data');
        }
      );
    }
  }

  getCurrentMessagePartnerId(item) {
    if (item && item.partnerId) {
      return item.partnerId;
    }
  }
}
